const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'group-research');
const Entry = resolve => require.ensure([], () => resolve(require('./Entry.vue')), 'group-research');
const Homework = resolve => require.ensure([], () => resolve(require('./Homework.vue')), 'group-research');
const Log = resolve => require.ensure([], () => resolve(require('./Log.vue')), 'group-research');
const Task = resolve => require.ensure([], () => resolve(require('./Task.vue')), 'group-research');

export default [{
  path: '/expert/train/activities',
  name: 'expert_train_activity_index',
  component: Index,
  meta: {
    title: '我的培训',
    layout: 'center',
  },
}, {
  path: '/expert/train/activities/:activityId/entries',
  name: 'expert_train_activity_entry_index',
  component: Entry,
  meta: {
    title: '教改项目',
    layout: 'center',
  },
}, {
  path: '/expert/train/entries/:entryId/homeworks',
  name: 'expert_train_entry_homework_index',
  component: Homework,
  meta: {
    title: '作业管理',
    layout: 'center',
  },
}, {
  path: '/expert/train/tasks/:taskId/homeworks',
  name: 'expert_train_task_homework_index',
  component: Homework,
  meta: {
    title: '作业管理',
    layout: 'center',
  },
}, {
  path: '/expert/train/activities/:activityId/logs',
  name: 'expert_train_activity_log_index',
  component: Log,
  meta: {
    title: '日志管理',
    layout: 'center',
  },
}, {
  path: '/expert/train/entries/:entryId/logs',
  name: 'expert_train_entry_log_index',
  component: Log,
  meta: {
    title: '日志管理',
    layout: 'center',
  },
}, {
  path: '/expert/train/activities/:activityId/tasks',
  name: 'expert_train_activity_task_index',
  component: Task,
  meta: {
    title: '任务管理',
    layout: 'center',
  },
}];



// WEBPACK FOOTER //
// ./src/pages/expert/train/index.js